import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { journeyConfigEntryPoint } from '@atlassian/jira-spa-apps-project-settings-servicedesk-journey-config/entrypoint.tsx';

export const journeyConfigPageEntryPoint = createPageEntryPoint({
	main: journeyConfigEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
